import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-128" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-129" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Take a Look Inside Your PMU Teaching System" body="Real educational resources designed to help you prepare more organized, engaging PMU classes." data-id="element-130" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-131" data-mp="235c8rru243o5">
          <InsidePagesCarousel data-id="element-132" data-mp="1y7kdcnu7dzf7" />
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center font-body text-[13px] text-brand-charcoal/60" data-id="element-133" data-mp="1y8c1jdlh0uvg">
          These are examples of the educational materials included in the system. Tap any page to enlarge it.
        </p>
      </div>
    </section>;
}